import { render, staticRenderFns } from "./_base-TooltipChip.vue?vue&type=template&id=5b61277c&scoped=true"
import script from "./_base-TooltipChip.vue?vue&type=script&lang=js"
export * from "./_base-TooltipChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b61277c",
  null
  
)

export default component.exports